import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualResendPageRoutingModule } from './manual-resend-routing.module';

import { ManualResendPage } from './manual-resend.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualResendPageRoutingModule
  ],
  declarations: [ManualResendPage],
  exports: [
    ManualResendPage
  ],
})
export class ManualResendPageModule {}
